import * as React from "react"
import { Link } from "gatsby"

const ProductSide = ({posts}) => {

  return (
    <div className="grid grid-cols-1 space-y-6">
    {posts.slice(0, 5).map((post,index) => {
        const title = post.frontmatter.title
        const url = post.frontmatter.url
        const img = post.frontmatter.image
        const category = post.frontmatter.category
        const price = post.frontmatter.price
        const formatter = new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY'
        });
        const currency = formatter.format(price)

        return (
          <article
            key={index}
            itemScope
            itemType="http://schema.org/Article"
          >
            <Link to={`/${url}`} itemProp="url">
              <div className="relative">
                <img className="border-[1px] border-slate-200 object-cover object-left h-[200px] w-full rounded-lg" src={img} alt={title} loading="lazy" />
              </div>
              <p className="mt-2 font-bold">
                <span itemProp="headline">{title}</span>
              </p>
              <div className="hidden mt-2 flex justify-between items-center">
                <p className="text-gray-600 font-bold">{category}</p>
                <p className="font-bold">{currency}</p>
              </div>
            </Link>
          </article>
        )
      })}
    </div>
  )
}

export default ProductSide